import { Controller } from '@hotwired/stimulus';
class default_1 extends Controller {
    switch(event) {
        event.preventDefault();
        const clickedTab = event.currentTarget;
        const targetPaneId = clickedTab.dataset.tabsPaneParam;
        const index = this.tabTargets.indexOf(clickedTab);
        if (index === -1)
            return;
        this.tabTargets.forEach((tab, i) => {
            const isMatch = targetPaneId ? tab.dataset.tabsPaneParam === targetPaneId : i === index;
            const activeClasses = tab.dataset.tabsActiveClass ? tab.dataset.tabsActiveClass.split(' ') : this.activeTabClasses;
            const inactiveClasses = tab.dataset.tabsInactiveClass ? tab.dataset.tabsInactiveClass.split(' ') : this.inactiveTabClasses;
            if (isMatch) {
                if (activeClasses.length)
                    tab.classList.add(...activeClasses);
                if (inactiveClasses.length)
                    tab.classList.remove(...inactiveClasses);
                tab.setAttribute('aria-selected', 'true');
            }
            else {
                if (activeClasses.length)
                    tab.classList.remove(...activeClasses);
                if (inactiveClasses.length)
                    tab.classList.add(...inactiveClasses);
                tab.setAttribute('aria-selected', 'false');
            }
        });
        this.paneTargets.forEach((pane, i) => {
            const isMatch = targetPaneId ? pane.id === targetPaneId : i === index;
            if (isMatch) {
                if (this.hasActivePaneClass)
                    pane.classList.add(...this.activePaneClasses);
                if (this.hasInactivePaneClass)
                    pane.classList.remove(...this.inactivePaneClasses);
                pane.classList.remove('d-none');
                pane.classList.add('show', 'active');
            }
            else {
                if (this.hasActivePaneClass)
                    pane.classList.remove(...this.activePaneClasses);
                if (this.hasInactivePaneClass)
                    pane.classList.add(...this.inactivePaneClasses);
                pane.classList.add('d-none');
                pane.classList.remove('show', 'active');
            }
        });
    }
}
default_1.targets = ['tab', 'pane'];
default_1.classes = ['activeTab', 'inactiveTab', 'activePane', 'inactivePane'];
export default default_1;
